import type { CSSProperties } from 'react'
import { APP_ICON_REGISTRY } from '../../constants/appSuites'
import type { AppIconKey, LauncherApp } from '../../types/appSuites'
import './AppSidebarIdentity.css'

export function AppSidebarIdentity({ app, collapsed }: { app: LauncherApp; collapsed: boolean }) {
  const Icon = APP_ICON_REGISTRY[app.icon as AppIconKey]
  return (
    <div className="app-sidebar-identity" style={{ '--app-accent': app.accent_color } as CSSProperties}>
      <span className="app-sidebar-identity__mark" aria-hidden="true">
        {Icon ? <Icon size={16} /> : null}
      </span>
      {!collapsed && <span className="app-sidebar-identity__name">{app.name}</span>}
    </div>
  )
}
